import { ENDPOINTS_DELEGATIONS } from 'common/endpoints/delegations.endpoints';

export default class DelegationService {

  constructor($http) {
    'ngInject';
    this.http = $http;
  }

  getDelegations(employeeId, service) {
    let config = {
      params: {
        service: service,
      },
    };
    return this.http.get(ENDPOINTS_DELEGATIONS.get.delegations(employeeId), config);
  }

  getDelegableEmployees(nameToSearch, employee) {
    return this.http.get(ENDPOINTS_DELEGATIONS.get.delegableEmployees(employee), {
      params: {
        employeeName: nameToSearch,
      },
    });
  }

  cancelDelegation(employeeId, delegationToDelete) {
    let config = {
      data: delegationToDelete,
    };
    return this.http.delete(ENDPOINTS_DELEGATIONS.delete.delegations(employeeId), config);
  }

  updateDelegations(employeeId, delegationToUpdate) {
    return this.http.put(ENDPOINTS_DELEGATIONS.put.delegations(employeeId),  delegationToUpdate);
  }

  createDelegations(employeeId, delegationToCreate) {
    return this.http.post(ENDPOINTS_DELEGATIONS.post.delegations(employeeId), delegationToCreate);
  }

}



// WEBPACK FOOTER //
// ./client/app/common/services/delegations.service.js